import Actions from "../../actions";
import * as requestFromServer from "./offerApis";
import { toastService } from "../../../component/common/toast-messages/toast";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";

// get all offer -> api
export const getOffers = (setLoading, dataToBeSent) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getOffer(dataToBeSent);
  if (response) {
    dispatch(Actions.createAction(Actions.GET_OFFER_LIST, response));
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// api -> create offer
export const addOffer =
  (offerBody, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createOffer(offerBody);
    if (response) {
      toastService.success(response?.message);
      dispatch(Actions.createAction(Actions.CREATE_OFFER, offerBody));
      setLoading(false);
      navigate(baseRouteMaker(routes.OFFER));
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> get offer by id
export const getOfferById =
  (offerBody, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getOfferById(offerBody);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_OFFER_BY_ID, offerBody));
      navigate(baseRouteMaker(routes.CREATE_OFFER));
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> update offer
export const updateOffer =
  (offerBody, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateOffer(offerBody);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      dispatch(Actions.createAction(Actions.EDIT_OFFER, offerBody));
      navigate(baseRouteMaker(routes.OFFER));
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> get offer by id
export const deleteOfferById = (offerBody, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.deleteOfferById(offerBody);
  if (response) {
    toastService.success(response?.message);
    setLoading(false);
    dispatch(Actions.createAction(Actions.DELETE_OFFER_BY_ID, offerBody));
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

export const purchaseOfferSponsorshipAction =
  (
    dataToBeSent,
    setLoading,
    setOpenPaymentConfirmationDialog,
    resetDefaultFields
  ) =>
  async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.purchaseOfferSponsorship(
      dataToBeSent
    );
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_COUPON, {
          validateCouponData: {},
        })
      );
      setOpenPaymentConfirmationDialog(true);
      resetDefaultFields();
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const purchasePackageSponsorshipAction =
  (
    dataToBeSent,
    setLoading,
    setOpenPaymentConfirmationDialog,
    resetDefaultFields
  ) =>
  async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.purchasePackageSponsorship(
      dataToBeSent
    );
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_COUPON, {
          validateCouponData: {},
        })
      );
      setOpenPaymentConfirmationDialog(true);
      resetDefaultFields();
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const purchaseOrganizationTopListingSubscriptionPlanAction =
  (
    dataToBeSent,
    setLoading,
    setOpenPaymentConfirmationDialog,
    resetDefaultFields
  ) =>
  async (dispatch) => {
    setLoading(true);
    const response =
      await requestFromServer.purchaseOrganizationTopListingSubscriptionPlan(
        dataToBeSent
      );
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_COUPON, {
          validateCouponData: {},
        })
      );
      setOpenPaymentConfirmationDialog(true);
      resetDefaultFields();
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
